import { render, staticRenderFns } from "./IconSvgILMANewsFeed.vue?vue&type=template&id=14bcc9e4&scoped=true&"
import script from "./IconSvgILMANewsFeed.vue?vue&type=script&lang=js&"
export * from "./IconSvgILMANewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bcc9e4",
  null
  
)

export default component.exports